<template>
  <div class="flipper-buttons">
    <button @click="setTab(1)" class="flipper-buttons__button"
            :class="{'active': isActiveTab(1)}">
      <span class="icon-year-planning"></span>
      {{$t('vue2.sub_scheduler.schedules_overview')}}
    </button>
    <button @click="setTab(0)" class="flipper-buttons__button"
            :class="{'active': isActiveTab(0)}">
      <span class="icon-file-text"></span>
      {{$t('vue2.sub_scheduler.list')}}
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      preselectedTab: {
        default: 0
      }
    },
    data () {
      return {
        activeTab: this.preselectedTab
      }
    },
    methods: {
      setTab (num) {
        this.activeTab = num
        this.$emit('update', num)
      },
      isActiveTab (num) {
        return num === this.activeTab
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .flipper-buttons {
    display: flex;
    justify-content: flex-end;
  }

  .flipper-buttons__button {
    display: flex;
    align-items: center;
    background-color: transparent;
    color: rgba(44, 62, 80, 0.65);
    height: 38px;
    min-width: 130px;
    margin: 0;
    border-radius: 0;
  }

  .flipper-buttons__button:first-child {
    border-radius: 3px 0 0 3px;
  }

  .flipper-buttons__button:nth-child(2) {
    border-radius: 0 3px 3px 0;
  }

  .flipper-buttons__button.active {
    background-color: white;
    color: #2c3e50;
    border: none;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  }

  .flipper-buttons__button.active > span {
    color: var(--blue);
  }

  .flipper-buttons__button span {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// AppFlipperButtons.vue?6d563d72